import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { getOrders, updateAOrder } from "../features/auth/authSlice";
const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Product",
    dataIndex: "product",
  },
  {
    title: "Amount",
    dataIndex: "amount",
  },
  {
    title: "Date",
    dataIndex: "date",
  },

  {
    title: "Action",
    dataIndex: "action",
  },
];
const getTokenFromLocalStorage = localStorage.getItem("user")
? JSON.parse(localStorage.getItem("user"))
: null;

const config3 = {
headers: {
  Authorization: `Bearer ${
    getTokenFromLocalStorage !== null ? getTokenFromLocalStorage.token : ""
  }`,
  Accept: "application/json",
},
};
const Orders = () => {
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [urlMap, setUrlMap] = useState({}); // Map of orderId → url

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrders(config3));
  }, [dispatch]);

  const orderState = useSelector((state) => state?.auth?.orders.orders);

  const handleSubmit = (id) => {
    const url = urlMap[id];
    if (url) {
      dispatch(updateAOrder({ id: id, orderStatus: "Shipped", shipUrl: url }));
      setSelectedOrderId(null);
      setUrlMap((prev) => ({ ...prev, [id]: "" }));
    }
  };

  const handleStatusChange = (orderId, status) => {
    if (status === "Shipped") {
      setSelectedOrderId(orderId);
      // Pre-fill with existing URL if available
      const existingOrder = orderState?.find((o) => o._id === orderId);
      setUrlMap((prev) => ({
        ...prev,
        [orderId]: existingOrder?.shipUrl || "",
      }));
    } else {
      setSelectedOrderId(null);
    }
    dispatch(updateAOrder({ id: orderId, status }));
  };

  const data1 = [];
  for (let i = 0; i < orderState?.length; i++) {
    const order = orderState[i];
    const orderId = order?._id;

    data1.push({
      key: i + 1,
      name: order?.user?.firstname,
      product: (
        <Link to={`/admin/order/${orderId}`}>View Orders</Link>
      ),
      amount: order?.totalPrice,
      date: new Date(order?.createdAt).toLocaleString(),
      action: (
        <>
          <select
            name=""
            defaultValue={order?.orderStatus}
            onChange={(e) =>
              handleStatusChange(orderId, e.target.value)
            }
            className="form-control form-select"
          >
            <option value="Ordered" disabled>
              Ordered
            </option>
            <option value="Processed">Processed</option>
            <option value="Shipped">Shipped</option>
            <option value="Out for Delivery">Out for Delivery</option>
            <option value="Delivered">Delivered</option>
            <option value="Cancelled">Cancelled</option>
          </select>

          {selectedOrderId === orderId && (
            <div className="mt-2">
              <input
                type="text"
                placeholder="Enter Shipping URL"
                value={urlMap[orderId] || ""}
                onChange={(e) =>
                  setUrlMap((prev) => ({
                    ...prev,
                    [orderId]: e.target.value,
                  }))
                }
                className="form-control mb-2"
              />
              <button
                onClick={() => handleSubmit(orderId)}
                className="btn btn-primary btn-sm"
              >
                Submit
              </button>
            </div>
          )}
        </>
      ),
    });
  }

  return (
    <div>
      <h3 className="mb-4 title">Orders</h3>
      <div>{<Table columns={columns} dataSource={data1} />}</div>
    </div>
  );
};


export default Orders;
